<template>
	<div class="dropdown-menu overflow-auto overflow-container bg-grey"
		:class="{ 'show': showCategoryDropdown, 'full-width mt-0': isMobileView }"
		aria-labelledby="dropdownMenuButton"
		@mouseover="toggleDropdown(true)"
		@mouseleave="toggleDropdown(false)">
		<a class="dropdown-item"
			:class="{ 'text-primary': category.slug === categoryQuery }"
			v-for="category in allCategories"
			:key="category._id"
			@click="goToSearch(category.slug)">
			<b>{{ category.name }}</b>
		</a>
	</div>
</template>

<script>
export default {
	name: 'CategoryDropdownMenu',
	data() {
		return {
			selectedCategory: '',
			filteredCategory: [],
		};
	},
	props: {
		showCategoryDropdown: {
			type: Boolean,
			default: () => false,
		},
		allCategories: {
			type: Array,
			default: () => [],
		},
		isMobileView: {
			type: Boolean,
			default: () => false,
		},
	},
	methods: {
		filterCategory() {
			if (this.selectedCategory) {
				this.filteredCategory = this.allCategories.find(category => category.slug === this.selectedCategory);
			}
		},
		goToSearch(categorySlug, subCategorySlug = '', subSubCategorySlug = '') {
			let url = '/search?';
			url += (categorySlug) ? `c=${categorySlug}` : '';
			url += (subCategorySlug) ? `&sc=${subCategorySlug}` : '';
			url += (subSubCategorySlug) ? `&ssc=${subSubCategorySlug}` : '';
			this.$router.push(url);
			this.toggleDropdown(false);
		},
		toggleDropdown(isOpen = true) {
			this.$emit('toggle', isOpen);
		},
	},
	computed: {
		categoryQuery() {
			return this.$route.query?.c;
		},
	},
	watch: {
		selectedCategory() {
			this.filterCategory();
		},
		allCategories(value) {
			if (value.length > 0) {
				this.selectedCategory = value[0].slug;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.category-link:hover {
	color: #006DC7;
}

.overflow-container {
	max-height: 50vh;
}

.border-left {
	border-left: 1px solid #eee;
}

.align-dropdown {
	margin-left: 200px;
}

.full-width {
	width: 100%;
}
</style>
